import {ID, Response} from '../../../../../../_metronic/helpers'
import { NULL } from 'sass';
import { date } from 'yup';
export type User = {
  id?: ID
  name?: string
  email?: string
  phone_number?: string
  roleId?: ID
  status?: boolean
  createdAt?: string
  updatedAt?: string
  uid?: string
  deletedAt?: string
  avatar?: string 
  gender?: string
  d_o_b?: Date
  social_security?: string
}

export type UsersQueryResponse = Response<Array<User>>

export const initialUser: User = {
  avatar: 'avatars/300-6.jpg',
  name: '',
  phone_number:'',
  email: '',
  roleId: 0,
  status: true,
  uid:'',
  deletedAt:'',
  gender:'',
  d_o_b: new Date(),
  social_security: ''
}
